import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IStateParamsService } from 'angular-ui-router';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';

interface IPageDo0016 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Do0016Controller(
    $stateParams: IStateParamsService,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass
) {
    const vm: IPageDo0016 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            effaceCriteres: true,
            rechercheCollapsable: false
        },
        criteresSuggeres: new Formulaire([
            new FormulaireItem('grgcleint', {
                default: $stateParams.grgcleint,
                readonly: true
            })
        ]),
        colonnesVisibles: [
            { nom: 'eplnummat', largeur: 180 },
            { nom: 'eplnom', largeur: 180 },
            { nom: 'lemcod', largeur: 180 },
            { nom: 'lem', largeur: 180 },
            { nom: 'istdat', largeur: 180 },
            { nom: 'istdatfin', largeur: 180 },
            { nom: 'vacvalcle', largeur: 180 },
            { nom: 'vacdsc', largeur: 180 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('demcleint'),
            new FormulaireItem('lemcleint', {
                resourceParams: (data: any) => ({ demcleint: data.demcleint })
            }),
            new FormulaireItem('istdat'),
            new FormulaireItem('istdat'),
            new FormulaireItem('istdatfin'),
            new FormulaireItem('vacistrai'),
            new FormulaireItem('grgcleint', {
                default: $stateParams.grgcleint
            })
        ])
    };
}

